/**
 * Created by sagardesai on 10/07/18.
 */
import {RSAA} from 'redux-api-middleware';
import {API_ENDPOINT, AUTH_HEADERS, X_AUTHORIZATION} from "../../util/constants";
import * as types from "../types";
import {handleUnauthorizedAccess} from "../../util/utility";


export function getFollowersList(token, api_token, query, filter_by, page) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/followers?api_token=${api_token}&filter_by=${filter_by}&query=${query}&page=${page}`,
            method: 'GET',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            types: [types.FOLLOWERS_LIST_REQUEST, types.FOLLOWERS_LIST_RECEIVE, {
                type: types.FOLLOWERS_LIST_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const resetFollowersList = () => ({
    type: types.RESET_FOLLOWERS_LIST,
    payload: null
});

export const setSearchFollowersState = (state) => ({
    type: types.SET_SEARCH_FOLLOWERS_STATE,
    payload: state
});


